import { employees } from '../../components/Employee/mock/employees';

const doEmployeesRequest = async (metaData) => {
  // const requestURL = `${process.env.REACT_APP_API_BASE_URL}/employees/list`;
  // return fetch(requestURL, options)
  //     .then(checkStatus)
  //     .then(parseJSON);

  let data = employees;

  // Filter
  const filters = metaData.filters;
  if (filters.length > 0) {
    console.log('mock:filter');
    data = data.filter((employee) => {
      let found = false;
      filters.forEach(({ field, value }) => {
        if (employee[`${field}`].indexOf(value) > -1) {
          found = true;
        }
      });
      console.log('mock:filter:found', found);
      return found;
    });
  }

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const value = await delay(1000);
  console.log(value);

  // Sorting
  const { field, order } = metaData.sorting;
  if (field) {
    if (order === 'ascend') {
      data.sort((a, b) => (a.id > b.id ? 1 : b.id > a.id ? -1 : 0));
    } else {
      data.sort((a, b) => (a.id < b.id ? 1 : b.id < a.id ? -1 : 0));
    }
  }

  // Pagination
  const { page, pageSize } = metaData.pagination;
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const total = data.length;
  data = data.slice(start, end);
  // const newMetaData = {
  //   ...metaData,
  //   pagination: {
  //     ...metaData.pagination,
  //     total
  //   },
  // };
  // metaData.pagination.total = total;

  console.log('mock:employees:newMetaData', metaData);
  console.log('mock:employees:pagedData', data);

  return {
    data: data,
    totalRecords: total,
  };
};

const doGetEmployeeByIdRequest = async (id) => {
  let data = employees.find((emp) => emp.id === id);

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));
  const value = await delay(1000);
  console.log(value);

  return {
    data,
  };
};

export { doEmployeesRequest, doGetEmployeeByIdRequest };
